import type { Typed } from 'services/api/fields/core';

export interface CredentialOptions {
  id?: string;
  description?: string;
  title: string;
  [key: string]: any;
}

function getDefaults(): CredentialOptions {
  return {
    id: '',
    description: '',
    title: '',
  };
}

let Credential: new <T extends CredentialOptions>(options: T) => Typed<_Credential<T>, T>;

class _Credential<T extends CredentialOptions = CredentialOptions> {
  constructor(options: T) {
    const opts = { ...getDefaults(), ...options };
    Object.assign(this, opts);
  }
}

// eslint-disable-next-line prefer-const
Credential = _Credential as typeof Credential;

export default Credential;
export { Credential };
export type Credential<T extends CredentialOptions = CredentialOptions> = Typed<_Credential<T>, T>;
